import { render, staticRenderFns } from "./badge-label.vue?vue&type=template&id=08c60c8a"
import script from "./badge-label.vue?vue&type=script&lang=js"
export * from "./badge-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports